import { getDateAggregationKey } from "../../../utils/getDateAggregationKey";

interface Row {
    time: string;
    value: number;
}

interface Props {
    data: Row[];
    average: number;
}

export function RawDataTableWidget({ data, average }: Props) {
    return (
        <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ padding: "0.5rem", borderBottom: "1px solid var(--surface-glass-border)" }}>Time</th>
                            <th style={{ padding: "0.5rem", borderBottom: "1px solid var(--surface-glass-border)" }}>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...data, { time: "Average", value: average }].map((row, i) => (
                            <tr key={i} style={{
                                fontWeight: row.time === "Average" ? "bold" : "normal",
                                backgroundColor: row.time === "Average" ? "var(--surface-glass-highlight)" : "inherit",
                            }}>
                                <td style={{ padding: "0.5rem", borderBottom: "1px solid var(--surface-glass-border)" }}>
                                    {row.time === "Average" ? row.time : getDateAggregationKey(row.time)}
                                </td>
                                <td style={{ padding: "0.5rem", borderBottom: "1px solid var(--surface-glass-border)" }}>
                                    {typeof row.value === 'number' ? row.value.toFixed(4) : row.value}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
